// extracted by mini-css-extract-plugin
export var bodyLocked = "Menu-module--body-locked--0a319";
export var items = "Menu-module--items--78f37";
export var menu = "Menu-module--menu--e22a1";
export var panel = "Menu-module--panel--2d348";